﻿import { FunctionComponent } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { EntitySelection } from "./components/EntitySelection";
import { CandidateGrid } from "./components/CandidateGrid";
import { SetPageTitle } from "../../components/SetPageTitle";
import { Box } from "@chakra-ui/react";
import { useClientEntities } from "../../api";
import { Shimmer } from "@am-tax/fe-core";

export const ClientCandidatesPage: FunctionComponent = () => {
    const { cId } = useParams();

    const [searchParams] = useSearchParams();
    const entityId = searchParams.get("eId") ?? undefined;
    const entitiesQuery = useClientEntities(cId || "");

    return (
        <>
            <SetPageTitle title={`Candidates`} />

            <Shimmer isLoading={entitiesQuery.isLoading}>
                {cId && !entitiesQuery.isLoading && (
                    <CandidateGrid
                        clientId={cId}
                        entityId={entityId}
                        entitiesQuery={entitiesQuery}
                        before={
                            <Box mb={"2rem"}>
                                <EntitySelection clientId={cId} />
                            </Box>
                        }
                    />
                )}
            </Shimmer>
        </>
    );
};
